import * as React from 'react';
import {Check} from 'lucide-react';
import {cn} from '../../lib/cn';

type VisualCheckboxProps = {
  checked: boolean;
  disabled?: boolean;
  className?: string;
};

function VisualCheckbox({checked, disabled, className}: VisualCheckboxProps) {
  return (
    <span
      aria-hidden="true"
      data-state={checked ? 'checked' : 'unchecked'}
      className={cn(
        'checkbox__control pointer-events-none flex h-4 w-4 shrink-0 items-center justify-center rounded-sm border border-solid',
        checked
          ? 'border-[var(--checkbox-checked-border)] bg-[var(--checkbox-checked-bg)] text-[var(--checkbox-check-color)]'
          : 'border-[var(--checkbox-border)] bg-[var(--checkbox-bg)]',
        disabled && 'opacity-50',
        className,
      )}
    >
      {checked && <Check className="checkbox__icon h-3 w-3" />}
    </span>
  );
}

export {VisualCheckbox};
export type {VisualCheckboxProps};
